export type UserClient = {
  id: string;
  name: string;
  usinas: string[];
  roles: string[];
  whatsappNotificationConfiguration?: WhatsappNotificationConfiguration;
};

export type WhatsappConfigurationType = {
  name: string;
  enabled: boolean;
};

export type WhatsappNotificationConfiguration = {
  canReceiveWhatsappNotification?: boolean;
  whatsappNotificationsEnabled: boolean;
  reportMonthlyConfiguration: WhatsappConfigurationType;
  reportPartialConfiguration: WhatsappConfigurationType;
  reportDailyConfiguration: WhatsappConfigurationType;
  alarmsBlandConfiguration: WhatsappConfigurationType;
  alarmsMediumConfiguration: WhatsappConfigurationType;
  alarmsSevereConfiguration: WhatsappConfigurationType;
};

export type UserCluster = {
  id: string;
  name: string;
};
export type User = {
  id: string;
  name: string;
  email: string;
  password: string;
  cpf: string | null;
  phone: string | null;
  notificationConfiguration: NotificationConfiguration;
  clients: UserClient[];
  resetLayout: boolean | null;
  lastActivity: Date | null;
  clusterIdAndName?: UserCluster[];
};
export type PostUser = Omit<User, "id">;

export type PatchUser = Partial<PostUser>;

export type ConfigurationType = {
  name: string;
  enabled: boolean;
  sendByMethods: string[];
};

export type NotificationConfiguration = {
  notificationsEnabled: boolean;
  reportMonthlyConfiguration: ConfigurationType;
  reportDailyConfiguration: ConfigurationType;
  reportPartialConfiguration: ConfigurationType;
  alarmsBlandConfiguration: ConfigurationType;
  alarmsMediumConfiguration: ConfigurationType;
  alarmsSevereConfiguration: ConfigurationType;
};

export type Role = {
  id: string;
  name: string;
  resources: string[];
};

export enum UserRoles {
  Admin = "Administrador",
  User = "Usuário",
  Technician = "Técnico",
  Client = "Cliente",
  Maintenance = "Manutenção",
  ClientAdm = "Cliente Adm",
}
